import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'app/store'

export interface BookingCodeTabsState {
  isFormChanged: {
    addBookingCode: boolean
  }
}

export const initialState: BookingCodeTabsState = {
  isFormChanged: {
    addBookingCode: false
  }
}

export const bookingCodeTabsSlice = createSlice({
  name: 'bookingCodeTabs',
  initialState: initialState,
  reducers: {
    setIsFormChangedAddBookingCode: (state, action) => {
      state.isFormChanged.addBookingCode = action.payload
    },
    resetState: (state) => {
      state.isFormChanged = initialState.isFormChanged
    }
  }
})

export const {
  setIsFormChangedAddBookingCode,
  resetState
} = bookingCodeTabsSlice.actions

export const bookingCodeTabsSelector = (state: RootState) =>
  state.bookingCodeTabs as BookingCodeTabsState

export default bookingCodeTabsSlice.reducer
